
import { Options, Vue } from "vue-class-component"; //基本需要\
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readGetSimpleDateOptions,
  readGetSimpleTypeOptions,
  readGetSimpleDeviceOptions,
  readGetSimpleData,
  readGetSimplSubtypeOptions,
  readGetSimpleSceneOptions,
  readGetSimpleReportOptions,
  readGetSimpleUrl,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchSimpleDateOptions,
  dispatchSimpleTypeOptions,
  dispatchSimpleDeviceOptions,
  dispatchSimpleData,
  dispatchNzmUploadReportImage,
  dispatchSimpleSubtypeOptions,
  dispatchSimpleSceneOptions,
  dispatchSimpleReportOptions,
  dispatchSimpleUpdateReport,
  dispatchSimpleUrl,
} from "@/store/performance/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";

import {
  readMyProjects,
  readProjectDetail,
  readAdminProjects,
} from "@/store/project/getters";
import { number } from "echarts/core";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class DcStatistics extends Vue {
  public edit = false;
  public sendOut() {
    this.edit = !this.edit;
  }
  public filterList = {
    date: "",
    type: "",
    subtype: "",
    scene: "",
    uuid: "",
    id_test: "",
  };
  public handleEdit() {
    this.dialogFormVisible1 = true;
    this.form1.name = (readGetSimpleReportOptions(store) as any[]).filter(
      (item: any) => item.id_test === this.filterList.id_test
    )[0].report_name;
    // this.form1.name=edit_name.slice(0,edit_name.indexOf('】')+1)
  }
  public getHead(item) {
    if (item == "label") {
      if (this.filterList.type == "3" || this.filterList.type == "4") {
        return "测试皮肤";
      } else {
        return "测试场景";
      }
    } else {
      return item;
    }
  }
  public getType(k, i) {
    if (i === 0) {
      if (this.filterList.type == "3" || this.filterList.type == "4") {
        return (k = "测试皮肤");
      } else {
        return (k = "测试场景");
      }
    } else {
      return k;
    }
  }
  public typeName() {
    if (this.filterList.type == "3" || this.filterList.type == "4") {
      return "测试皮肤";
    } else {
      return "测试场景";
    }
  }
  public;
  public imgHead = ["测试场景", "查看火焰图", "火焰图下载", "数据下载"];
  public localProject = Number(getLocalProject());
  public async mounted() {
    this.loading = true;
    if (
      this.$route.query.date &&
      this.$route.query.subtype &&
      this.$route.query.scene_id
    ) {
      (this.filterList.date as any) = this.$route.query.date;
      (this.filterList.type as any) = Number(this.$route.query.report_type);
      (this.filterList.scene as any) = Number(this.$route.query.scene_id);

      (this.filterList.uuid as any) = this.$route.query.UUID;
      (this.filterList.subtype as any) = Number(this.$route.query.subtype);
      (this.filterList.id_test as any) = Number(this.$route.query.id_test);

      if (Number(this.filterList.type) === 4) {
        this.$router.push({
          path: "/simple_perf_skin",
          query: {
            ...this.$route.query,
            date: this.filterList.date,
            report_type: Number(this.filterList.type),
            UUID: this.filterList.uuid,
            scene_id: this.filterList.scene,
            subtype: this.filterList.subtype,
            id_test: this.filterList.id_test,
          },
        });
        this.loading = false;
        return;
      }
      await dispatchSimpleDateOptions(store, {
        project: this.localProject,
      });

      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
      });
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      });
      await dispatchSimpleSceneOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
      });
      await dispatchSimpleDeviceOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        report_type: Number(this.filterList.type),
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });

      await dispatchSimpleReportOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        UUID: this.filterList.uuid,
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });
      this.formMail.title = readGetSimpleReportOptions(store).filter(
        (item) => item.id_test == this.filterList.id_test
      )[0].report_name;
      await dispatchSimpleData(store, {
        project: this.localProject,
        date: this.filterList.date,
        report_type: Number(this.filterList.type),
        UUID: this.filterList.uuid,
        subtype: Number(this.filterList.subtype),
        id_test: Number(this.filterList.id_test),
        scene_id: Number(this.filterList.scene),
      });
      await dispatchSimpleUrl(store, {
        project: this.localProject,
        id_test: Number(this.filterList.id_test),
      });
      await this.simpleData;
      await this.picData;
      await this.textData;
      await this.trendData;
      this.resBase64 = [];
      (this.trendData as any).label.forEach((v, index) => {
        this.$nextTick(() => {
          this.drawPieChart(v, index);
        });
      });
    } else {
      await dispatchSimpleDateOptions(store, {
        project: this.localProject,
      });
      this.filterList.date = readGetSimpleDateOptions(store)[0].date;
      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
      });
      this.filterList.type = readGetSimpleTypeOptions(store)[0]?.report_type;
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      });
      this.filterList.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      await dispatchSimpleSceneOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.scene = readGetSimpleSceneOptions(store)[0].scene_id;
      await dispatchSimpleDeviceOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });

      const option = readGetSimpleDeviceOptions(store).find(item => item.name.includes('J200')) || readGetSimpleDeviceOptions(store)[0]
      this.filterList.uuid = option?.UUID;

      await dispatchSimpleReportOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        UUID: this.filterList.uuid,
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.id_test = readGetSimpleReportOptions(store)[0].id_test;
      this.formMail.title = readGetSimpleReportOptions(store).filter(
        (item) => item.id_test == this.filterList.id_test
      )[0].report_name;
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.filterList.date,
          report_type: Number(this.filterList.type),
          subtype: Number(this.filterList.subtype),
          scene_id: this.filterList.scene,
          UUID: this.filterList.uuid,
          id_test: Number(this.filterList.id_test),
        },
      });
      await dispatchSimpleData(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        UUID: this.filterList.uuid,
        subtype: Number(this.filterList.subtype),
        id_test: Number(this.filterList.id_test),
        scene_id: Number(this.filterList.scene),
      });
      await dispatchSimpleUrl(store, {
        project: this.localProject,
        id_test: Number(this.filterList.id_test),
      });
      await this.simpleData;
      await this.picData;
      await this.textData;
      await this.trendData;
      this.resBase64 = [];
      (this.trendData as any).label.forEach((v, index) => {
        this.$nextTick(() => {
          this.drawPieChart(v, index);
        });
      });
    }
    this.loading = false;
  }
  public get simpleUrl() {
    return readGetSimpleUrl(store);
  }
  public getNum(item1, item2, type) {
    if (item1 == "") {
      return "";
    }
    item1 = Number(item1);
    item2 = Number(item2);
    if (type == "avg_fps") {
      if (item1 > item2) {
        return "(" + (item1 - item2).toFixed(2) + "↑" + ")";
      } else if (item1 < item2) {
        return "(" + (item2 - item1).toFixed(2) + "↓" + ")";
      }
      if (item1 === item2) {
        return "(--)";
      }
    }
    if (type == "avg_fps_single") {
      if (item1 > item2) {
        return "(" + (item1 - item2).toFixed(2) + "↑" + ")";
      } else if (item1 < item2) {
        return "(" + (item2 - item1).toFixed(2) + "↓" + ")";
      }
      if (item1 === item2) {
        return "(--)";
      }
    }

    // if (type === "avg_fps") {
    //    if (item1 > item2) {
    //     return "(" + (item1 - item2).toFixed(2) + "↑" + ")";
    //   } else if (item1 < item2) {
    //     return "(" + (item2 - item1).toFixed(2) + "↓" + ")";
    //   }
    //   if (item1 === item2) {
    //     return "(--)";
    //   }
    // }
    else {
      if (item1 > item2) {
        return "(" + ((item1 - item2) * 100).toFixed(2) + "↑" + ")";
      } else if (item1 < item2) {
        return "(" + ((item2 - item1) * 100).toFixed(2) + "↓" + ")";
      }
      if (item1 === item2) {
        return "(--)";
      }
    }
  }
  public async dialogFormVisible2() {
    this.dialogFormVisible1 = false;
    await dispatchSimpleUpdateReport(store, {
      project: this.localProject,
      id_test: Number(this.filterList.id_test),
      report_name: String(this.form1.name),
    });
    readGetSimpleReportOptions(store).filter(
      (item) => item.id_test === this.filterList.id_test
    )[0].report_name = this.form1.name;
  }
  public dateList = [];
  public typeList = [];
  public deviceList = [];
  public subtypeList = [];
  public reportList = [];
  public packageBtn() {
    if (this.simpleUrl === "") {
      ElMessage.error("无对应的流水线");
    } else {
      window.open(this.simpleUrl, "_blank");
    }
  }
  public save_report(is_auto?: boolean) {
    let upload_data: any;

    upload_data = {
      project: this.localProject,
      file_list: this.resBase64,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
      report_type: this.filterList.type,
      date: this.filterList.date,
      UUID: this.filterList.uuid,
      subtype: Number(this.filterList.subtype),
      scene_id: Number(this.filterList.scene),
      id_test: Number(this.filterList.id_test),
    };
    dispatchNzmUploadReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }

  public get dateOptions() {
    this.dateList = readGetSimpleDateOptions(store);
    return this.dateList;
  }
  public btn(link) {
    const routeUrl = this.$router.resolve({
      path: "/dmo",
      query: { name: link },
    });
    window.open(routeUrl.href, "_blank");
  }
  public drawPieChart(item, index) {
    let ordinates: any[] = [];
    this.trendData[item].params.forEach((v, i) => {
      let list = [];
      ordinates.push({
        name: v,
        type: "line",
        data: this.trendData[item].series[i],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });

    let performance_line: any = document.getElementById(
      "performance_line" + item
    ) as HTMLElement;
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      title: {
        type: "scroll",
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
        data: this.trendData[item].label,
      },
      yAxis: {
        type: "value",
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.trendData[item].date,
      },

      series: ordinates,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.type = item;
    res.file_base64 = res_base64;
    res.filename = "simPleReport" + index + ".png";
    this.resBase64.push(res);
  }
  public resBase64: any[] = []; // 趋势图存储
  public getColor(data, type) {
    if (type == true) {
      if (data?.indexOf("↑") != -1) {
        return "#00b050";
      } else if (data.indexOf("↓") != -1) {
        return "red";
      } else {
        return "#212529";
      }
    } else {
      if (data?.indexOf("↑") != -1) {
        return "red";
      } else if (data?.indexOf("↓") != -1) {
        return "#00b050";
      } else {
        return "#212529";
      }
    }
  }
  public getNone(item, type) {
    if (type === "avg_fps_single" || type === "avg_fps") {
      return item / 100;
    } else {
      return item;
    }
  }
  public loading = false; //加载
  public get typeOptions() {
    this.typeList = readGetSimpleTypeOptions(store);
    return this.typeList;
  }
  public get deviceOptions() {
    this.deviceList = readGetSimpleDeviceOptions(store);
    return this.deviceList;
  }
  public get subtypeOptions() {
    this.subtypeList = readGetSimplSubtypeOptions(store);
    return this.subtypeList;
  }

  public get reportOptions() {
    this.reportList = readGetSimpleReportOptions(store);
    return this.reportList;
  }
  public dialogFormVisible1 = false;
  public formLabelWidth = "";
  public form1 = {
    name: "",
  };

  public async date(type) {
    this.loading = true;
    if (type === "date") {
      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
      });
      this.filterList.type = readGetSimpleTypeOptions(store)[0].report_type;
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      });
      this.filterList.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      await dispatchSimpleSceneOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.scene = readGetSimpleSceneOptions(store)[0].scene_id;
      await dispatchSimpleDeviceOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });

      this.filterList.uuid = (readGetSimpleDeviceOptions(store).find(item => item.name.includes('J200')) || readGetSimpleDeviceOptions(store)[0])?.UUID;

      await dispatchSimpleReportOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        UUID: this.filterList.uuid,
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.id_test = readGetSimpleReportOptions(store)[0].id_test;
    }
    if (type === "type") {
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      });
      this.filterList.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      await dispatchSimpleSceneOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.scene = readGetSimpleSceneOptions(store)[0].scene_id;
      await dispatchSimpleDeviceOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });

      this.filterList.uuid = (readGetSimpleDeviceOptions(store).find(item => item.name.includes('J200')) || readGetSimpleDeviceOptions(store)[0])?.UUID;

      await dispatchSimpleReportOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        UUID: this.filterList.uuid,
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.id_test = readGetSimpleReportOptions(store)[0].id_test;
    }
    if (type === "subtype") {
      await dispatchSimpleSceneOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.scene = readGetSimpleSceneOptions(store)[0].scene_id;
      await dispatchSimpleDeviceOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });
      
      this.filterList.uuid = (readGetSimpleDeviceOptions(store).find(item => item.name.includes('J200')) || readGetSimpleDeviceOptions(store)[0])?.UUID;

      await dispatchSimpleReportOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        UUID: this.filterList.uuid,
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.id_test = readGetSimpleReportOptions(store)[0].id_test;
    }
    if (type === "device") {
      await dispatchSimpleReportOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        UUID: this.filterList.uuid,
        subtype: Number(this.filterList.subtype),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.id_test = readGetSimpleReportOptions(store)[0].id_test;
    }
    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.filterList.date,
        report_type: Number(this.filterList.type),
        UUID: this.filterList.uuid,
        scene_id: this.filterList.scene,
        subtype: this.filterList.subtype,
        id_test: this.filterList.id_test,
      },
    });
    if (Number(this.filterList.type) == 4) {
      this.$router.push({
        path: "/simple_perf_skin",
        query: {
          ...this.$route.query,
          date: this.filterList.date,
          report_type: Number(this.filterList.type),
          UUID: this.filterList.uuid,
          scene_id: this.filterList.scene,
          subtype: this.filterList.subtype,
          id_test: this.filterList.id_test,
        },
      });

      this.loading = false;
      return;
    }
    this.formMail.title = readGetSimpleReportOptions(store).filter(
      (item) => item.id_test == this.filterList.id_test
    )[0].report_name;
    await dispatchSimpleData(store, {
      project: this.localProject,
      date: this.dateOptions.length > 0 ? this.filterList.date : "",
      report_type:
        this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      UUID: this.filterList.uuid,
      subtype: Number(this.filterList.subtype),
      id_test: Number(this.filterList.id_test),
      scene_id: Number(this.filterList.scene),
    });
    await dispatchSimpleUrl(store, {
      project: this.localProject,
      id_test: Number(this.filterList.id_test),
    });

    await this.simpleData;
    await this.picData;
    await this.textData;
    await this.trendData;
    this.resBase64 = [];
    await (this.trendData as any).label.forEach((v: any, index: any) => {
      this.$nextTick(() => {
        this.drawPieChart(v, index);
      });
    });
    this.loading = false;
  }
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public tableObj = {};
  public text = [];
  public pic = {};
  public trend = {};
  public get simpleData() {
    this.tableObj = readGetSimpleData(store).data;
    return this.tableObj;
  }
  public get picData() {
    this.pic = readGetSimpleData(store).pic;
    return this.pic;
  }
  public get textData() {
    this.text = readGetSimpleData(store).text;

    return this.text;
  }
  public getText(item) {
    if (item === "") {
      return "--";
    } else {
      return item;
    }
  }
  public get trendData() {
    this.trend = readGetSimpleData(store).trend;
    return this.trend;
  }

  public name_search = "";
  //声明属性
  // public tableObj={
  //     UnityMain中各线程消耗:{head:[{name:'测试皮肤',value:'testName'},{name:'平均帧率',value:'avg'},{name:'单帧平均耗时',value:'avgMs'},{name:'UnityMain',value:'unity'},{name:'UnityGfx',value:'unityGfx'},{name:'CoreThread',value:'corethead'},{name:'NativeThread',value:'navite'},{name:'WorkerThread(*2)',value:'work'},{name:'Other',value:'other'}],list:[{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'1.20%'}]},
  //     UnityMain中各模块消耗:{head:[{name:'测试皮肤',value:'testName'},{name:'平均帧率',value:'avg'},{name:'单帧平均耗时',value:'avgMs'},{name:'UnityMain',value:'unity'},{name:'UnityGfx',value:'unityGfx'},{name:'CoreThread',value:'corethead'},{name:'NativeThread',value:'navite'},{name:'WorkerThread(*2)',value:'work'},{name:'Other',value:'other'}],list:[{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'6.20%'}]}
  //     ,UnityMain中各SO消耗:{head:[{name:'测试皮肤',value:'testName'},{name:'平均帧率',value:'avg'},{name:'单帧平均耗时',value:'avgMs'},{name:'UnityMain',value:'unity'},{name:'UnityGfx',value:'unityGfx'},{name:'CoreThread',value:'corethead'},{name:'NativeThread',value:'navite'},{name:'WorkerThread(*2)',value:'work'},{name:'Other',value:'other'}],list:[{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'6.20%'}]}
  //     ,火焰图展示:{head:[{name:'测试皮肤',value:'testName'},{name:'火焰图下载链接',value:'link'},],list:[{testName:'10500-云中君-经典',link:'下载',},{testName:'10500-云中君-经典',link:'下载',}]}
  // }
}
